export const LoginPath = 'login';
export const DashboardPath = 'dashboard';
export const AIAssistantPath = 'aiAssistant';
export const WorkingEfficienyPath = 'workingEfficieny';
export const MovementEfficienyPath = 'movementEfficieny';
export const UsageEfficienyPath = 'usageEfficieny';
export const LoadEfficienyPath = 'loadEfficieny';
export const AdminViewPath = 'adminView';
export const RealTimeMapViewPath = 'realTimeMapView';
export const ComparisionAnalysisPath = 'comparisionAnalysis';
export const RawDataPath = 'rawData';
export const AppConfigPath = 'appConfig';
export const HeatmapPath = 'heatmap';
export const EfficiencySummaryPath = 'efficiencySummary';
export const EfficiencySummaryV2Path = 'efficiencySummaryV2';
export const ShiftMovementSummaryPath = 'shiftMovementAnalysis';
export const OperatorSummaryPath = 'operatorSummary';
export const OperatorComparingSummaryPath = 'operatorComparing';
export const AlarmsPath = 'alarms';
export const AlarmSetsPath = 'alarmSets';
export const AlarmReportsPath = 'alarmReports';
export const IndoorManagementPath = 'indoorManagement';
export const VenueManagementPath = 'venueManagement';
export const UserSettingsPath = 'userSettings';
export const UserAggrementPath = 'userAggrement';
export const SignUpPath = 'signUp';
export const TrnaslationsPath = 'translations';
export const BatteryPath = 'battery';
export const PrivacyPolicyPath = 'privacy-policy';
export const ForkliftDetailPath = 'forklift';
export const WorkingHoursPath = 'workingHours';
export const BulkForkliftPath = 'bulkForklift';
export const BulkDevicePath = 'bulkDevice';
export const BulkOperatorPath = 'bulkOperator';
export const BulkUserPath = 'bulkUser';
export const BulkBatteryPath = 'bulkBattery';
export const GeofencingRegionManagementPath = 'geofencingRegionManagement';
export const EmailPath = 'email';
export const AuditPath = 'audit';
export const AIConfigPath = 'aiConfig';
export const AppStatusPath = 'appStatus';
export const MaintenanceLogPath = 'maintenanceLog';
export const PlanningPath = 'planning';
export const DailyEfficiencySummaryPath = 'dailyEfficiencySummary';
export const UnauthorizedUsagePath = 'unauthorizedUsage';
export const AiReportsPath = 'aiReports';
export const AiGuidePath = 'aiGuide';
export const AiTokenUsagePath = 'aiTokenUsage';
export const SafetyPath = 'safety';
export const BreachPath = 'breach';
export const IndoorMapsPath = 'indoorMaps';
export const OpeningPagePath = DashboardPath;